import type { ProviderId } from "@indeed/signals-schema/com/indeed/signals/schema/reactnative/ProviderId";
import {
  JSTReportLevel,
  type JSTReport as JSTReportPayload,
  type JSTReportOptions,
} from "@indeed/tare/internal/JSTReport";

export { JSTReportLevel };
export type { JSTReportOptions };
export type JSTReport = JSTReportPayload;

function createReport(
  level: JSTReportLevel,
  providerId: ProviderId,
  message: string,
  options: JSTReportOptions = {},
): JSTReport {
  return {
    level,
    providerId,
    message,
    stack: options.stack ?? null,
    componentStack: options.componentStack ?? null,
    url: options.url ?? null,
    statusCode: options.statusCode ?? null,
    errDomain: options.errDomain ?? null,
    errCode: options.errCode ?? null,
    context: options.context ?? null,
    containsPII: options.containsPII ?? false,
  };
}

export const JSTReport = {
  info(providerId: ProviderId, message: string, options?: JSTReportOptions): JSTReport {
    return createReport(JSTReportLevel.INFO, providerId, message, options);
  },
  warn(providerId: ProviderId, message: string, options?: JSTReportOptions): JSTReport {
    return createReport(JSTReportLevel.WARN, providerId, message, options);
  },
  error(providerId: ProviderId, message: string, options?: JSTReportOptions): JSTReport {
    return createReport(JSTReportLevel.ERROR, providerId, message, options);
  },
};
